import React, { Component } from "react";
import Carousel from "../../components/Carousel";
import FeaturedProducts from "../../components/FeaturedProducts";
import RecentlyAddedProducts from "../../components/RecentlyAddedProducts";
import FooterTop from "../../components/shared/FooterTop";

export default class Home extends Component {
  render() {
    return (
      <React.Fragment>
        <Carousel />
        <FeaturedProducts />
        <RecentlyAddedProducts />
        <FooterTop />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routers/Home/index.js